export default __webpack_public_path__ + "static/media/P500MANE4.2902ef2f.pdf";